import $ from 'jquery';
import mergeOptions from 'styleguide/lib/merge-options';

const DEFAULTS = {};
const CONTAINER_CLASS = '.js-revieve-container';
const BUTTON_CLASS = '.js-revieve-try-on';
const rcProps = window.rcProps || {};

export default function(options) {
    if (!rcProps.revieveEventEnabled) {
        return;
    }

    const opts = mergeOptions(DEFAULTS, options, $(BUTTON_CLASS));

    try {
        if (opts.isPlp) {
            if (opts.checkAvailability) {
                let codes = [];
                $('li.js-plp-container').each((index, element) => {
                    const $element = $(element);
                    $element.attr('data-loader', 'tryOnLoader');
                });
                $('li.js-plp-container').Lazy({
                    tryOnLoader: function(element, response) {
                        console.log('revieve layload');
                        const $element = $(element);
                        const code = $element.attr('id');
                        Revieve.API.liveAR.isTryOnAvailable({ product_id: code }, (available) => {
                            if (available) {
                                $element.find(CONTAINER_CLASS).removeClass('u-hide');
                                codes.push(code);
                            }
                        });
                    }
                }); 
                Revieve.API.liveAR.loadTryOnProducts(codes);
            }
        } else {
            Revieve.API.liveAR.isTryOnAvailable({ product_id: opts.code }, (available) => {
                if (available) {
                    $(CONTAINER_CLASS).removeClass('u-hide');
                }
            });
        }
    } catch (ignored) {

    }

    setEventListeners();
}

function setEventListeners() {
    $(document).on('click', BUTTON_CLASS, (e) => {
        e.preventDefault();
        Revieve.API.liveAR.addTryOnProduct($(e.target).data('code'));
        Revieve.API.show();
        // VTO stands for Virtual Try On
        logEngagement(window.location.href, 'VTO', 'Open');
    });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/revieve-try-on.js